import { WorldpayIntegrationType } from '../../models/worldpay/worldpay-integration-type.enum';
import { WorldpayOptions } from '../../models/worldpay/worldpay-options.interface';

export const mockWorldpayOptions: WorldpayOptions = {
  accessibility: true,
  customisation: {},
  debug: false,
  iframeHelperURL: 'https://www.mysite.com/helper.html',
  inject: 'immediate',
  target: 'worldpay-form-iframe',
  type: WorldpayIntegrationType.Iframe,
  url: 'url',
};
